import Builder from 'react-native-jala-orm/src/model/Builder';
import _ from 'lodash';
import Expression from 'react-native-jala-orm/src/query/Expression';
import SyncableModel from './SyncableModel';
import Cycle from './Cycle';

export default class Harvest extends SyncableModel {
    static name = 'Harvest'

    _fillable = [
      'id', 'cycle_id', 'weight',
      'size', 'harvested_at', 'selling_price', 'status', 'remark', 'buyer',
      'created_at', 'updated_at', 'deleted_at', 'synced_at',
    ]

    static _parents = ['cycle'];

    static endpoint = '/harvests'

    static allowReplaceUpdate = true

    static _boot() {
      super._boot();

      this.addGlobalScope('global', (query: Builder) => {
        if (_.isEmpty(query.getQuery().columns)) {
          query.select([query.qualifyColumn('*')]);
        }

        const cycle = (new Cycle()).setTable(`${query.getModel().getTable()}_cycles`);
        query.leftJoin(
          `${(new Cycle()).getTable()} as ${cycle.getTable()}`,
          cycle.getQualifiedKeyName(), query.qualifyColumn(cycle.getForeignKey())
        );
      });
    }

    qualifyColumn(column: string): string {
      if (column === '*') {
        return new Expression(
          `${this.getTable()}.*, `
            + `${this.qualifyColumn('weight_accumulation')} as weight_accumulation, `
            + `${this.qualifyColumn('age')} as age`
        );
      }
      if (column === 'weight_accumulation') {
        const harvest = (new this.constructor()).setTable(_.uniqueId('t'));
        const harvestQuery = this.constructor.query().withoutGlobalScopes()
          .selectRaw(`SUM(${harvest.qualifyColumn('weight')})`)
          .table(this.getTable(), harvest.getTable())
          .whereColumn(harvest.qualifyColumn('cycle_id'), this.qualifyColumn('cycle_id'))
          .where((query: Builder) => query
            .whereColumn(harvest.qualifyColumn('harvested_at'), '<', this.qualifyColumn('harvested_at'))
            .orWhere((q: Builder) => q
              .whereColumn(harvest.qualifyColumn('harvested_at'), '=', this.qualifyColumn('harvested_at'))
              .where((q1: Builder) => q1
                .whereColumn(harvest.qualifyColumn('size'), '<', this.qualifyColumn('size'))
                .orWhere((q2: Builder) => q2
                  .whereColumn(harvest.qualifyColumn('size'), '=', this.qualifyColumn('size'))
                  .whereColumn(harvest.getQualifiedKeyName(), '<', this.getQualifiedKeyName()))))
            .orWhereColumn(harvest.getQualifiedKeyName(), this.getQualifiedKeyName()));
        return new Expression(`(${harvestQuery.toSql()})`);
      }
      if (column === 'age') {
        const cycle = (new Cycle()).setTable(`${this.getTable()}_cycles`);
        return new Expression(
          '('
            + 'CAST('
              + `(JULIANDAY(${this.qualifyColumn('harvested_at')}) - `
                + `JULIANDAY(${cycle.qualifyColumn('started_at')})) AS INTEGER`
              + `) + COALESCE(${cycle.qualifyColumn('initial_age')}, 0)`
            + ')'
        );
      }
      return super.qualifyColumn(column);
    }

    relationCycle() {
      return Cycle.query().withoutGlobalScope('soft_delete').whereKey(this.cycle_id);
    }
}
